// Per-country rules for the delivery-address form (the shopper picks a Google Maps suggestion).

// Countries where Google often knows the street but not the exact house number (Guatemala: "7a Avenida
// 14-25, Zona 10" comes back as the street only). There the street, zone, city, state and postal code
// still come from Google and the shopper types just the door number. Everywhere else (Colombia included)
// the picked address must already be complete. Add a country code here to relax it for that country.
export const MANUAL_NUMBER_COUNTRIES = new Set(['GT']);

// A realistic address in each country's own style, shown in the "pick a complete address" message.
// Countries without an entry get the message without an example.
export const ADDRESS_EXAMPLES = {
  CO: 'Calle 122 # 11C-51',
  GT: '7a Avenida 14-25, Zona 10',
  MX: 'Av. Insurgentes Sur 1602',
  US: '1000 Brickell Avenue',
  PE: 'Av. Larco 345',
  CL: 'Av. Providencia 1234',
  AR: 'Av. Corrientes 1234',
  BR: 'Av. Paulista 1578',
  EC: 'Av. Amazonas N24-03',
  UY: 'Av. 18 de Julio 1234',
  DO: 'Av. Winston Churchill 1099',
};

export const allowsManualNumber = (country) => MANUAL_NUMBER_COUNTRIES.has((country || '').toUpperCase());

export const addressExample = (country) => ADDRESS_EXAMPLES[(country || '').toUpperCase()] || '';

// A house number: has a digit and only number-like characters ("14-25", "6a-55", "11C-51"), or "S/N" (sin número).
// Same rule as the server (utils/address_check.py).
export const isValidHouseNumber = (value) => /^(?:s\/?n|(?=.*\d)[A-Za-z0-9#\-./ ]{1,20})$/i.test(String(value || '').trim());
